module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group row password-notifications"
  }, [(!_vm.hidePasswordNotifications) ? _c('p', {
    class: ['bg-danger', 'pppoe-warning', 'col-md-12']
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" Customers configured for PPPoE must also update their router password.")]) : _vm._e()]), _vm._v(" "), (_vm.requireOldPassword) ? _c('div', {
    staticClass: "form-group"
  }, [_c('show-password-field', {
    attrs: {
      "label": 'Current password',
      "name": 'password',
      "required": true,
      "maxlength": _vm.passwordMaxLength
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  }), _vm._v(" "), (!_vm.oldPasswordIsValid) ? _c('small', {
    staticClass: "pw-warnings"
  }, [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v("\n          You must enter your current password\n        ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.suggestionsInModal) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    attrs: {
      "variant": "light",
      "id": "pw-help"
    },
    on: {
      "click": function($event) {
        _vm.modalVisible = true
      }
    }
  }, [_vm._v("Help me create a secure password")])], 1) : _c('div', {
    class: !_vm.passwordInModal ? 'col-md-6' : 'col-md-12'
  }, [_c('div', [_c('b-card', {
    attrs: {
      "no-body": "",
      "id": "passGen",
      "header-text-variant": "white"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "btn btn-primary btn-block collapsed",
          on: {
            "click": function($event) {
              _vm.collapseVisible = !_vm.collapseVisible
            }
          }
        }, [_vm._v("Help me create a secure password "), _c('span', {
          staticClass: "float-right"
        }, [_c('i', {
          class: ['bi', _vm.collapseVisible ? 'bi-caret-up-fill' : 'bi-caret-down-fill']
        })])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "password-collapse"
    },
    model: {
      value: (_vm.collapseVisible),
      callback: function($$v) {
        _vm.collapseVisible = $$v
      },
      expression: "collapseVisible"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('password-generator', {
    attrs: {
      "password-label": _vm.passwordLabel
    }
  })], 1)])], 1)], 1)])]), _vm._v(" "), _c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('show-password-field', {
    ref: "newPassword",
    staticClass: "mb-2",
    attrs: {
      "label": _vm.passwordLabel,
      "help": _vm.passwordHelp,
      "minlength": _vm.passwordMinLength,
      "maxlength": _vm.passwordMaxLength,
      "required": true,
      "name": "new-password"
    },
    on: {
      "toggle": function($event) {
        return _vm.toggleShowNewPass($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "faded"
  }, [_vm._v("Password strength")]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": _vm.passwordComplexity,
      "striped": "",
      "height": "10px",
      "variant": "success",
      "animated": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pw-warnings"
  }, [(_vm.dangerSuggestion) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('b', {
    staticClass: "text-danger"
  }, [_c('b-icon-x-lg', {
    attrs: {
      "scale": "0.75"
    }
  }), _vm._v(" " + _vm._s(_vm.dangerSuggestion) + "\n                ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.warningSuggestion) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('b', {
    staticClass: "text-warning"
  }, [_c('b-icon-info-circle-fill'), _vm._v(" " + _vm._s(_vm.warningSuggestion) + "\n                ")], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('xm-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "new-password-confirm",
      "type": _vm.showNewPass ? 'text' : 'password',
      "required": "",
      "maxlength": _vm.passwordMaxLength,
      "label": _vm.passwordConfirmLabel
    },
    model: {
      value: (_vm.newPassConfirm),
      callback: function($$v) {
        _vm.newPassConfirm = $$v
      },
      expression: "newPassConfirm"
    }
  }), _vm._v(" "), (!_vm.passwordsMatch) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b-icon-x-lg', {
    attrs: {
      "scale": "0.75"
    }
  }), _vm._v(" Passwords do not match.")], 1)]) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Generate Password",
      "id": "password-generator-modal",
      "size": "lg"
    },
    model: {
      value: (_vm.modalVisible),
      callback: function($$v) {
        _vm.modalVisible = $$v
      },
      expression: "modalVisible"
    }
  }, [_c('password-generator', {
    attrs: {
      "password-label": _vm.passwordLabel
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cdfb3cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordForm.vue
// module id = 1340
// module chunks = 16